namespace Matrix.Data {
    export interface ClientTableForm {
        ExistingTable: Serenity.LookupEditor;
        TableSchema: Serenity.StringEditor;
        Tablename: Serenity.StringEditor;
        Identifier: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        InstanceName: Serenity.StringEditor;
        Extends: FormatLookupEditor;
        IdFieldName: Serenity.StringEditor;
        NameFieldName: Serenity.StringEditor;
        DisplayOrderField: Serenity.StringEditor;
        ReadPermission: Serenity.StringEditor;
        ModifyPermission: Serenity.StringEditor;
        LookupScript: Serenity.BooleanEditor;
        LookupPermission: Serenity.StringEditor;
        NavigationPath: Serenity.StringEditor;
        NavigationOrder: Serenity.IntegerEditor;
        NavigationIcon: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ClientTableForm extends Serenity.PrefixedContext {
        static formKey = 'Data.ClientTable';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientTableForm.init)  {
                ClientTableForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(ClientTableForm, [
                    'ExistingTable', w0,
                    'TableSchema', w1,
                    'Tablename', w1,
                    'Identifier', w1,
                    'DisplayName', w1,
                    'InstanceName', w1,
                    'Extends', w2,
                    'IdFieldName', w1,
                    'NameFieldName', w1,
                    'DisplayOrderField', w1,
                    'ReadPermission', w1,
                    'ModifyPermission', w1,
                    'LookupScript', w3,
                    'LookupPermission', w1,
                    'NavigationPath', w1,
                    'NavigationOrder', w4,
                    'NavigationIcon', w1,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
